import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { PageProps, graphql, navigate } from 'gatsby'
import React from 'react'
import SEO from '../components/seo'

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

type BlogArticle = {
  id: string
  data: {
    blurb: string
    image: string
    handle: string
    title: string
  }
}

interface Props extends PageProps {
  data: {
    allBuilderModels: {
      blogArticle: Array<BlogArticle>
    }
  }
}

const BlogPostsPage: React.FC<Props> = ({location, data}) => {
  const classes = useStyles();

  const blogPosts = data.allBuilderModels.blogArticle

  const handlePostClick = (handle:string) => {
    navigate(`/blog/${handle}`)
  }

  return (
    <>
      <SEO
      location={location}
      keywords={[
        `blog posts`,
        `HabFit blog`,
        `articles`,
        `recent blog articles`,
        `recent blog posts`,
        `fitness blog posts`,
        `personal training blog`,
        `affordable personal training`,
      ]}
      title="Blog"
      description="Check our recent blog posts about fitness, general health and wellness"
      />
      <Container>
        <Box mt={5} />
        <Typography variant="h3" color="primary" component="h1">Blog</Typography>
        <Box mt={5} />
        <Grid container spacing={2}>
          {
            blogPosts.map(post => {
              return (
                <Grid key={post.id} item sm={12} md={6} lg={4}>
                  <Card  className={classes.root}>
                    <CardActionArea onClick={()=>handlePostClick(post.data.handle)}>
                      <CardMedia
                        className={classes.media}
                        image={post.data.image}
                        title={post.data.title}
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="h2">
                          {post.data.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" component="p">
                          {post.data.blurb}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              )
            })
          }
        </Grid>
      </Container>
    </>
  )
}

export default BlogPostsPage

export const query = graphql`
  query{
    allBuilderModels {
      blogArticle(limit: 10) {
        id
        data {
          blurb
          image
          handle
          title
        }
      }
    }
  }
`
